export interface CustomerEnquirySearchCriteria {
    customerCodeList?: string[] | null,
    companyCodeList?: string[] | null,
    customerType?: string | null,
    activeInd?: string | null,

    [key: string]: string[] | string | boolean | number | Date | null | undefined
}

export const EMPTY_CUSTOMER_ENQUIRY_SEARCH_CRITERIA: CustomerEnquirySearchCriteria = {
    customerCodeList: [],
    companyCodeList: [],
    customerType: '',
    activeInd: ''
}